import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { CoalService } from 'app/services/coal.service';
import { AppState } from 'app/store/app.states';

@Component({
  selector: 'app-guia-transporte',
  templateUrl: './guia-transporte.component.html',
  styleUrls: ['./guia-transporte.component.scss']
})
export class GuiaTransporteComponent implements OnInit {
    //@OUTPUTS
    @Output() FormGuiaTransporteEventEmiter = new EventEmitter<any>();
    //@INPUTS
    @Input() title: any;
    @Input() data: any;
    //Formularios
    idguiatransporte;
    FormGuiaTransporte =      new FormGroup({
        cantidad:        new FormControl('',[Validators.required]),
        idorigen:         new FormControl('',[
            Validators.required,
            Validators.maxLength(8),
            Validators.minLength(8),
            Validators.pattern('^OR[0-9]{6}$')
        ]),
        iddestino:         new FormControl('',[
            Validators.required,
            Validators.maxLength(8),
            Validators.minLength(8),
            Validators.pattern('^DE[0-9]{6}$')
        ]),
    });
    constructor(
        private _snackBar: MatSnackBar,
        private store: Store<AppState>,
        private srvcoal: CoalService
    ) { }

    ngOnInit(): void {
        this.senddata();
        if(Object.keys(this.data).length){
            this.asignar_valores();
        }
    }
    asignar_valores(){
        this.FormGuiaTransporte.controls.cantidad.setValue(this.data.cantidad);
        this.FormGuiaTransporte.controls.idorigen.setValue(this.data.idOrigen);
        this.FormGuiaTransporte.controls.iddestino.setValue(this.data.idDestino);
    }

    senddata(){
        this.FormGuiaTransporte.statusChanges.subscribe(status => {
            if(this.FormGuiaTransporte.valid){
                let data = {transporte : this.FormGuiaTransporte.value,title : this.title}
                this.FormGuiaTransporteEventEmiter.emit(data);
            }
        });
    }

}
